import { IS_SPAIN_ENV } from '@modules/core/utils';

const locale = IS_SPAIN_ENV ? 'es-ES' : 'en-GB';

export const convertYearsAndMonthsToTotalMonths = (years: number, months: number) => (years * 12) + months;

export const convertToHumanReadableDate = (date: Date) => date.toLocaleDateString(locale, {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

export const convertToDDMMYYYYFormat = (date: string | Date) => {
  const isoDate = typeof date === 'object' ? date : new Date(date);
  return isoDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const formatToLocalTimeZone = (dateTime: string | number) => {
  const localDate = new Date();
  localDate.setTime(new Date(dateTime).getTime() - (new Date().getTimezoneOffset() * 1000 * 60));
  return localDate;
};
